// extracted by mini-css-extract-plugin
module.exports = {"title":"GameDetail_title__3dY7j","description":"GameDetail_description__3ugLz"};